import React from 'react';
import { Button, Dialog } from '@material-ui/core';
import enUs from "../../../lang/en-us";
import { useHistory } from 'react-router';

const { dbCommercial, dashboard } = enUs;
type IFSCErrorPropsType = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
export const IFSCError = ({open, setOpen }: IFSCErrorPropsType) => {
    const history = useHistory();
    return (
      <Dialog maxWidth={'sm'} open={open} aria-labelledby="note-modals">
          <div className="note-modals">
              <h3> {dbCommercial.errors.ifscBank} </h3>
              <p>Please click continue to update IFSC</p>
              <div className="note-modals-btns">
                  <Button className="customBtn cancelBtn" onClick={() => {
                    setOpen(false);
                  }}>
                      Cancel
                  </Button>
                  <Button className="customBtn" onClick={() => {
                    setOpen(false);
                    history.replace('/portal/nct/update-ifsc');
                  }}>
                      Continue
                  </Button>
              </div>
          </div>
      </Dialog>
    );
};
